module.exports = __webpack_public_path__ + "static/media/student-snapshort2-name.307506f6.png";